import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { TemplatesService } from 'src/app/business-service/inventory/templates.service';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
})
export class TemplatesComponent  implements OnInit {

  @Input() templateId:any;
  @Input() leadId:any;
  @Input() itineraryId:any;
  @Input() storedFormData:any;
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();
  
  allInventoryTemplates:any;

  sanitizedTemplates: any[] = [];

  selectedTemplateId:any;

  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private _templateService: TemplatesService,
    private _responseNotificationService: ResponseNotificationService,
    private _sanitizer: DomSanitizer, // Add DomSanitizer here
    private _fb: FormBuilder,
    private _globalService: GlobalService,
    private _itineraryService: ItineraryService
  ) { }

  ngOnInit() {

    this.selectedTemplateId = this.storedFormData.baseTemplateId;
    
    this.getAllDefaultTemplates();
  }

  changeSelectedTemplate(templateId:any){
    this.selectedTemplateId = templateId;   
    this.onSubmit(); 
  }

  getAllDefaultTemplates(){
    this._templateService.getAllTemplates(true, null, null, null).subscribe((data: any) => {
      this.allInventoryTemplates = data;      
      this.sanitizeAllTemplates(); // Call a method to sanitize the templates
    }, (error) => {
      this._responseNotificationService.showMessage("Something went wrong, please try again", true);
    });
  }

  sanitizeAllTemplates() {
    this.sanitizedTemplates = this.allInventoryTemplates.map((template: { content: string; }) => {
      return {
        ...template,
        content: this._sanitizer.bypassSecurityTrustHtml(template.content)
      };
    });
  }

  onSubmit(){
    if(this.selectedTemplateId){        
      this._itineraryService.updateQuoteTemplate(this.itineraryId, this.selectedTemplateId).subscribe((data)=>{
        // Store Submitted form data into parent component
        data.dataSaved = true;        
        this.storeFormData.emit(data);
      })
    }else{
      this._globalService.scrollToFirstInvalidControl();
      this._responseNotificationService.showMessage("Form is invalid, please fill all required fields.", true);
    }
  }

  goPrevious(){
    this.viewChange.emit(true)
  }

  goNext(){
    this.viewChange.emit(false)
  }
}
